/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { GrantOAuthPage } from '@/pages/GrantOAuth/GrantOAuthPage';

export function GrantOAuthRoute() {
  return <GrantOAuthPage />;
}
